import React from 'react';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Chip, Box, Typography, Paper, Divider,
  useTheme, useMediaQuery
} from '@mui/material';
import { COLOR_MAP } from '../constants';

export default function DeviceRecords({ data, filters }) {

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const DataRow = ({ label, value, color, bold, diff, icon }) => (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.5 }}>
      <Typography variant="body2" color="textSecondary">
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="body2" sx={{
          fontWeight: bold ? 'bold' : 'normal',
          color: color || 'inherit'
        }}>
          {value}
        </Typography>
        {diff && (
          <Typography variant="caption" sx={{ color: diff > 0 ? 'green' : 'red', fontWeight: 'bold' }}>
            {diff > 0 ? `+${diff}` : diff}
          </Typography>
        )}
        {icon && <span style={{ fontSize: '12px' }}>{icon}</span>}
      </Box>
    </Box>
  );

  return (
    isMobile ? (
      <Box>

        {data.map((row, index) => {
          if (!row.weight && !row.temperature) return null;

          return (
            <Paper key={index} sx={{ mb: 2, borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ bgcolor: 'greyCustom.soft', p: 1, pl: 2 }}>
                <Typography sx={{ fontWeight: 'bold' }}>{row.time}</Typography>
              </Box>

              <Box sx={{ p: 1.5 }}>
                <DataRow label="Βάρος:" value={`${row.weight?.toFixed(2)} Kg`} color="#0d47a1" bold
                        diff={row.diff} />
                <Divider sx={{ my: 0.5 }} />

                <DataRow label="Θερμοκρασία:" value={`${row.temperature}°C`} />
                <Divider sx={{ my: 0.5 }} />

                <DataRow label="Υγρασία:" value={`${row.humidity}%`} icon="🌧️" />
                <Divider sx={{ my: 0.5 }} />

                <DataRow label="Μπαταρία:" value={`${row.battery}%`} />
                <Divider sx={{ my: 0.5 }} />

                <DataRow label="Σήμα:" value={`${row.signal}%`} />
              </Box>
            </Paper>
          );
        })}
      </Box>
    ) : (
      <TableContainer component={Paper} sx={{ mt: 3, borderRadius: 2 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }}>
                {{
                  day: 'Ώρα',
                  month: 'Ημέρα',
                  year: 'Μήνας'
                }[filters.mode] || 'Ώρα'}
              </TableCell>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }} align="right">Βάρος (kg)</TableCell>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }} align="right">Θερμ. (°C)</TableCell>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }} align="right">Υγρασία</TableCell>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }} align="right">Μπαταρία</TableCell>
              <TableCell sx={{ backgroundColor: 'greyCustom.soft', fontWeight: 'bold' }} align="right">Σήμα</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .filter((row) => row.weight === undefined ? false : true)
              .map((row, index) => (

              <TableRow key={index} sx={{ '&:hover': { bgcolor: '#fffde7' } }}>
                <TableCell component="th" scope="row">{row.time}</TableCell>
                <TableCell align="right" sx={{ fontWeight: 'bold', color: '#0d47a1' }}>{row.weight?.toFixed(2)}</TableCell>
                <TableCell align="right" sx={{ color: row.temperature > 20 ? '#d32f2f' : '#1976d2' }}>{row.temperature ? `${row.temperature}°` : null}</TableCell>
                <TableCell align="right">{row.humidity ? `${row.humidity}%` : null}</TableCell>
                <TableCell align="right">
                  {row?.battery !== undefined && (
                    <Chip label={`${row.battery}%`} size="small" color={row?.battery > 20 ? "success" : "error"} variant="outlined" />
                  )}
                </TableCell>
                <TableCell align="right">{row.signal ? `${row.signal} dBm` : null}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  );
}
